import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { notificationTypeState } from '../../../storage/reports';

type Props = {
  notificationId: number;
};

function RouteReportNotificationType({ notificationId }: Props) {
  const notificationType = useRecoilValue(notificationTypeState(notificationId));

  if (!notificationType) return null;

  return <>{notificationType.name}</>;
}

export default memo(RouteReportNotificationType);
